
// Native IndexedDB wrapper to avoid dependency issues if npm fails
const DB_NAME = 'ContractsDB';
const DB_VERSION = 1;
const STORE_NAME = 'multiCarData';

// Cache database connection for performance
let dbInstance = null;

// const sanitizeError = (error) => {
//     // Return generic error message to prevent XSS
//     return 'Database operation failed';
// };

export const dbService = {
    open: () => {
        if (dbInstance) return Promise.resolve(dbInstance);

        return new Promise((resolve, reject) => {
            const request = indexedDB.open(DB_NAME, DB_VERSION);

            request.onerror = () => {
                reject(new Error('Database error'));
            };

            request.onupgradeneeded = (event) => {
                const db = event.target.result;
                if (!db.objectStoreNames.contains(STORE_NAME)) {
                    db.createObjectStore(STORE_NAME);
                }
            };

            request.onsuccess = (event) => {
                dbInstance = event.target.result;
                resolve(dbInstance);
            };
        });
    },

    save: async (key, data) => {
        const db = await dbService.open();
        return new Promise((resolve, reject) => {
            const transaction = db.transaction([STORE_NAME], 'readwrite');
            transaction.onerror = () => reject(new Error('Transaction failed'));
            const store = transaction.objectStore(STORE_NAME);
            const request = store.put(data, key);

            request.onsuccess = () => resolve(true);
            request.onerror = () => reject(new Error('Save failed'));
        });
    },

    get: async (key) => {
        const db = await dbService.open();
        return new Promise((resolve, reject) => {
            const transaction = db.transaction([STORE_NAME], 'readonly');
            transaction.onerror = () => reject(new Error('Transaction failed'));
            const store = transaction.objectStore(STORE_NAME);
            const request = store.get(key);

            request.onsuccess = () => resolve(request.result);
            request.onerror = () => reject(new Error('Get failed'));
        });
    },

    clear: async () => {
        const db = await dbService.open();
        return new Promise((resolve, reject) => {
            const transaction = db.transaction([STORE_NAME], 'readwrite');
            transaction.onerror = () => reject(new Error('Transaction failed'));
            const store = transaction.objectStore(STORE_NAME);
            const request = store.clear();
            request.onsuccess = () => resolve(true);
            request.onerror = () => reject(new Error('Clear failed'));
        });
    }
};
